<template>
  <WdsModal :show="show" :title="title" @cancel="$emit('cancel')">
    <WdsStack justify-center align-center direction-column gap-md class="content">
      <div class="icon-outer">
        <div class="icon-inner">
          <WdsIcon name="trash-can" color="#D12223" size="24"></WdsIcon>
        </div>
      </div>
      <WdsText large>
        {{ $t('Are you sure you want to delete this group?') }}
      </WdsText>
      <WdsText secondary>
        <BaseHtml
          :html="
            $t('This action <strong>cannot be undone</strong> and it will permanently delete it')
          "
        />
      </WdsText>
      <WdsStack justify-space-between align-center class="tw-w-full">
        <WdsButton @click="$emit('cancel')">{{ $t('Cancel') }}</WdsButton>
        <WdsButton error @click="$emit('submit')">{{ $t('Delete') }}</WdsButton>
      </WdsStack>
    </WdsStack>
  </WdsModal>
</template>

<script setup>
import { WdsText, WdsStack, WdsIcon, WdsModal, WdsButton } from '@worksome/wds-components'
import { computed } from 'vue'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import BaseHtml from '@/components/BaseHtml.vue'

defineEmits(['cancel', 'submit'])

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  groupName: {
    type: String,
    required: true,
  },
})

const title = computed(() => $t('Delete ":group-title"', { 'group-title': props.groupName }))
</script>

<style lang="scss" scoped>
.content {
  :deep(strong) {
    color: black;
  }

  .icon-outer {
    border-radius: 50%;
    background-color: #fdf2f2;
    padding: 6px;
    .icon-inner {
      padding: 5px;
      border-radius: 50%;
      background-color: #f9e0e0;
    }
  }
}
</style>
